import React from "react";
import PricingMobile from "../PricingMobile/PricingMobile";
import Pricing from "../Pricing/Pricing";

/**
 * ResponsivePricing component that switches between mobile and desktop
 * pricing components based on screen size.
 *
 * This component handles proper display of PricingMobile for small to medium screens
 * and Pricing for large screens and above.
 */
const ResponsivePricing = () => {
  return (
    <>
      <div id="pricing">
        {" "}
        <div className="block md:hidden">
          <PricingMobile />
        </div>
        {/* Desktop version */}
        <div className="hidden md:block">
          <Pricing />
        </div>
      </div>
    </>
  );
};

export default ResponsivePricing;
